import { authFetch } from "./authFetch";
import { API_BASE_URL } from "config/api";

const getToken = () =>
    localStorage.getItem("accessToken") || localStorage.getItem("token") || "";

/** Header Builder */
const authHeaders = () => ({
    "Content-Type": "application/json",
    Authorization: `Bearer ${getToken()}`
});

/** Kleine Helper: wirf klare Fehler, wenn Response nicht ok ist */
async function ensureOk(res) {
    if (res.ok) return res;
    const text = await res.text().catch(() => "");
    throw new Error(text || `Request failed (${res.status})`);
}

// Wir benutzen ausschlie�lich den Token, den authFetch selbst setzt
export const adminApi = {

    // GET /api/admin/users
    getUsers: async () => {
        const res = await authFetch(`${API_BASE_URL}/api/admin/users`);
        return await res.json();
    },

    // POST /api/admin/users
    createUser: async (payload) => {
        const res = await authFetch(`${API_BASE_URL}/api/admin/users`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload)
        });
        return await res.json();
    },

    // DELETE /api/admin/users/{id}
    deleteUser: async (userId) => {
        return await authFetch(`${API_BASE_URL}/api/admin/users/${userId}`, {
            method: "DELETE"
        });
    },

    // POST /api/admin/users/{id}/roles
    setUserRoles: async (userId, roles) => {
        return await authFetch(`${API_BASE_URL}/api/admin/users/${userId}/roles`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ roles })
        });
    },

    // GET /api/admin/roles
    getRoles: async () => {
        const res = await authFetch(`${API_BASE_URL}/api/admin/roles`);
        return await res.json();
    },

    // POST /api/admin/roles
    createRole: async (payload) => {
        const res = await authFetch(`${API_BASE_URL}/api/admin/roles`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload)
        });
        return await res.json();
    },

    // PUT /api/admin/roles/:id   (oder PATCH � je nach Backend)
    updateRole: async (roleId, payload) => {
        const res = await authFetch(`${API_BASE_URL}/api/admin/roles/${roleId}`, {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload),
        });
        return await res.json();
    },

    // DELETE /api/admin/roles/:id
    deleteRole: async (roleId) => {
        const res = await authFetch(`${API_BASE_URL}/api/admin/roles/${roleId}`, {
            method: "DELETE",
        });

        // manche Backends geben 204 No Content zur�ck
        if (res.status === 204) return true;

        // falls Backend JSON zur�ckgibt (z.B. { success: true })
        try {
            return await res.json();
        } catch {
            return true;
        }
    },
    activateUser: async (userId) => {
        await authFetch(`${API_BASE_URL}/api/admin/users/${userId}/activate`, {
            method: "PUT",
            headers: authHeaders()
        });
    },

    deactivateUser: async (userId) => {
        await authFetch(`${API_BASE_URL}/api/admin/users/${userId}/deactivate`, {
            method: "PUT",
            headers: authHeaders()
        });
    },
    getRoleRequests: async () => {
        const res = await authFetch(`${API_BASE_URL}/api/admin/role-requests`, {
            method: "GET",
            headers: authHeaders()
        });
        await ensureOk(res);
        return await res.json();
    },

    approveRoleRequest: async (id) => {
        const res = await authFetch(`${API_BASE_URL}/api/admin/role-requests/${id}/approve`, {
            method: "POST",
            headers: authHeaders()
        });
        await ensureOk(res);
    },

    rejectRoleRequest: async (id) => {
        const res = await authFetch(`${API_BASE_URL}/api/admin/role-requests/${id}/reject`, {
            method: "POST",
            headers: authHeaders()
        });
        await ensureOk(res);
    },

};
